import React from 'react';
import {dashboardText} from '../dashboardText';
import PageTitle from '../../../uiToolkit/PageTitle';
import './styles.css';
import {DashboardData} from '../../../data/models/Workspace/Dashboard';
import NoSubscriptionState from '../components/NoSubscriptionState';
import AiCreditsCard from '../components/AiCreditsCard';
import StorageCard from '../components/StorageCard';
import QuickLink from '../components/QuickLink';
import AiAssistantsCard from '../components/AiAssistantsCard';
import UsersCard from '../components/UsersCard';
import CreatorsCard from '../components/CreatorsCard';
import CoursesCard from '../components/CoursesCard';
import AvgScoreCard from '../components/AvgScoreCard';
import CourseProgressCard from '../components/CourseProgressCard';
import {Tour} from '../../../modules/Tour';
import {
  isBusinessSubscription,
  SUBSCRIPTION_ENTERPRISE,
} from '../../Subscription/config';

interface Props {
  dashboardData?: DashboardData;
  onSubscribe: () => void;
  onStartTrial: () => void;
  navigateCustomizeWorkspaceBranding: () => void;
  navigateManageAccount: () => void;
  navigateManageIntegrations: () => void;
  hasTrialExpired: boolean;
  usedTrial: boolean;
  isLoading: boolean;
  hasAdminPermissions: boolean;
  subscriptionPermissions: any;
  onContactUs: () => void;
  onBuyAddons: () => void;
  organizationId?: string;
  onOpenAssistants: () => void;
  canNavigateToLtiSettings: boolean;
  allowAddingCreators: boolean;
  subscriptionPlan?: number;
}

const WorkspaceUI = ({
  dashboardData,
  onSubscribe,
  hasAdminPermissions,
  hasTrialExpired,
  isLoading,
  onBuyAddons,
  organizationId,
  onOpenAssistants,
  canNavigateToLtiSettings,
  allowAddingCreators,
  subscriptionPlan,
}: Props) => {
  if (hasTrialExpired) {
    return (
      <NoSubscriptionState
        hasAdminPermissions={hasAdminPermissions}
        isLoading={isLoading}
        onSubscribe={onSubscribe}
      />
    );
  }

  if (!dashboardData) {
    return (
      <div className="WorkspaceContainer">
        <PageTitle title={dashboardText.title} />
      </div>
    );
  }

  return (
    <div className="WorkspaceContainer">
      <Tour section="dashboard" />
      <PageTitle title={dashboardText.title} />
      <p className="SectionHeader">{dashboardText.workspaceInsights}</p>

      <div className="Section StepOne">
        <AiCreditsCard
          onBuyAddons={onBuyAddons}
          creditsAvailable={dashboardData.aiCreditsAvailable}
        />
        <StorageCard
          onBuyAddons={onBuyAddons}
          storageAvailable={dashboardData.maxStorageSpaceAvailable}
          storageUsed={dashboardData.storageSpaceUsed}
        />
        <div className="LinksAndAssistants">
          <div className="QuickLinksContainer">
            <QuickLink
              url={`/${organizationId}/marketplace`}
              text={dashboardText.exploreAddons}
              icon="icon-icon_marketplace"
              disabled={
                subscriptionPlan === 0 || subscriptionPlan === undefined
              }
              tooltipText={dashboardText.notAvailableForTrialPlan}
            />
            <QuickLink
              url={`/manage/${organizationId}/settings/general`}
              text={dashboardText.customizeWorkspace}
              icon="icon-icon_customize"
            />
            <QuickLink
              url={
                canNavigateToLtiSettings
                  ? `/manage/${organizationId}/settings/lti_settings`
                  : `/manage/${organizationId}/settings/subscription`
              }
              text={dashboardText.exporeIntegrations}
              icon="icon-icon_settings"
            />
          </div>
          <AiAssistantsCard
            onOpenAssitstants={onOpenAssistants}
            aiAssistants={dashboardData.aiAssistantsNumber}
          />
        </div>
      </div>

      <p className="SectionHeader">{dashboardText.userInsights}</p>

      <div className="Section StepTwo">
        <UsersCard
          leaners={dashboardData.learnerNumbers}
          instructors={dashboardData.instructorNumbers}
          availalbe={dashboardData.maxLearnersAvailable}
          onBuyAddons={onBuyAddons}
        />
        <div className="CreatorsAndTime">
          <CreatorsCard
            onBuyAddons={onBuyAddons}
            creatorsAmount={dashboardData.amountOfCreators}
            totalCreatorsAmount={
              dashboardData?.maxAmountOfCreators?.toString() || ''
            }
            showTotalCreators={
              subscriptionPlan === SUBSCRIPTION_ENTERPRISE ||
              isBusinessSubscription(subscriptionPlan)
            }
            allowAddingCreators={allowAddingCreators}
          />
          {/* <TimeSpentCard /> */}
        </div>
        {/* <LearnersAmountCard
            learnersPerMonth={dashboardData.learnersPerMonth}
          /> */}
      </div>

      <p className="SectionHeader">{dashboardText.courseInsights}</p>

      <div className="Section StepThree">
        <div className="CoursesScore">
          <CoursesCard
            allCourses={dashboardData.draftCoursesNumbers}
            publishedCourses={dashboardData.courseNumbers}
          />
          <AvgScoreCard score={dashboardData.avgCoursesScore} />
        </div>
        <CourseProgressCard
          completedCourses={dashboardData.completedCourses}
          inProgressCourses={dashboardData.inProgressCourses}
          notStartedCourses={dashboardData.notStartedCourses}
        />
      </div>
    </div>
  );
};
export default WorkspaceUI;
